<template>
  <el-dialog
    append-to-body
    destroy-on-close
    v-if="visible"
    v-el-dialog-drag
    show-close
    width="900px"
    title="订单详情"
    visible
    :close-on-click-modal="false"
    @close="close"
    top="8vh"
  >
    <index-detail ref="indexDetail" :no="no" />
    <span slot="footer">
      <el-button size="small" @click="close()">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import IndexDetail from './index'
export default {
  components: {
    IndexDetail,
  },
  props: {
    visible: Boolean,
    no: String,
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
  overflow: hidden !important;
}
</style>

<style lang="scss">
.order-dialog {
  position: absolute !important;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: 0 auto !important;
  margin-top: 0 !important;
}
</style>
